import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Infraccion } from '../model/infracciones.model';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InfraccionService {
  private apiUrl =  `${environment.apiUrl}/api/infracciones`; 

  private conteoPorEstado = new BehaviorSubject<any>(null);
  conteoPorEstado$ = this.conteoPorEstado.asObservable(); 

  numero: any;
  documento: any;
  propietario: any;
  fecha: any;
  tipo: any;
  codigo: any;
  valortotal: any;
  vrpagado: any;
  vrsaldo: any;
  fechacompromiso: any;
  estado: any;
  observaciones!: string;

  constructor(private http: HttpClient) {}

  // Manejo centralizado de errores
  private manejarError(error: HttpErrorResponse): Observable<never> {
    let mensaje = 'Ocurrió un error inesperado';
    if (error.error?.message) {
      mensaje = error.error.message;
    }
    console.error('❌ Error en la petición HTTP:', error);
    Swal.fire({ icon: 'error', title: 'Error en la solicitud', text: mensaje });
    return throwError(() => new Error(mensaje));
  }

  // Obtener todas las infracciones y estadísticas
  getInfracciones(): Observable<{ infracciones: Infraccion[]; conteoPorEstado: any[] }> {
    return this.http.get<{ infracciones: Infraccion[]; conteoPorEstado: any[] }>(
      this.apiUrl,
      { withCredentials: true }
    ).pipe(catchError(this.manejarError));
  }

  // ✅ Nuevo método: obtener resumen (total, por estado, por tipo)
  getResumenInfracciones(): Observable<{ total: number; porEstado: any[]; porTipo: any[] }> {
    return this.http.get<{ total: number; porEstado: any[]; porTipo: any[] }>(
      `${this.apiUrl}/conteo`,
      { withCredentials: true }
    ).pipe(catchError(this.manejarError));
  }

  // Actualizar el estado de una infracción
  updateInfraccionEstado(numero: string, nuevoEstado: number): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      `${this.apiUrl}/${numero}`,
      { estado: nuevoEstado },
      { withCredentials: true }
    ).pipe(catchError(this.manejarError));
  }

  createInfraccion(data: any): Observable<any> {
    return this.http.post(this.apiUrl, data, { withCredentials: true }).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error) {
          return throwError(() => error.error); 
        }
        return throwError(() => ({ error: 'Error inesperado al crear la infracción' }));
      })
    );
  }

  // Eliminar una infracción por su número
  deleteInfraccion(numero: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${numero}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Actualizar una infracción existente
  updateInfraccion(numero: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${numero}`, data, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Obtener infracciones por documento
  getInfraccionesByDocumento(documento: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/cedula/${documento}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Actualizar las estadísticas (BehaviorSubject)
  actualizarEstadisticas(estadisticas: any) {
    this.conteoPorEstado.next(estadisticas);
  }

}
